import React, { useContext, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import getRoute from '@root/src/services/routeList';
import { mediaBreakpoint } from '@root/src/services/responsiveProvider';
import { StyledErrorMessage } from '@features/ui-input/formik/MultiInputLine';
import { ICON_NAME } from '@features/ui/components/Icon';
import {
  selectIsAuthenticated,
} from '@features/users/slices/userSlice';
import {
  selectEarliestNextSubscription,
  selectSubscriptionPack,
  selectSubscriptionsCategoryIds,
  selectSubscriptionsCount,
} from '@features/subscriptions/slices/formSubscriptionSlice';
import Button from '@features/ui/components/Button';
import { FormikContext } from './FormikContextProvider';

const SerieSubscriptionCartButton = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const { formikContexts } = useContext(FormikContext);

  const logged = useSelector(selectIsAuthenticated);
  const selectedPack = useSelector(selectSubscriptionPack);
  const subscriptionsCategoryIds = useSelector(selectSubscriptionsCategoryIds);
  const subscriptionCategoriesCount = useSelector(selectSubscriptionsCount);
  const earliestNextSubscription = useSelector(selectEarliestNextSubscription);

  const [showSubmitError, setShowSubmitError] = useState(false);

  const handleCartButtonClick = async () => {
    setShowSubmitError(false);

    const result = await Promise.all(
      subscriptionsCategoryIds.map(categoryId => formikContexts[categoryId]?.submitForm())
    );

    if (result.every(r => r?.success)) {
      router.push(
        getRoute.openModal(router)
          .categoryServices(
            earliestNextSubscription.category._idMso,
            earliestNextSubscription.event._idMso,
          ),
        null,
        { scroll: false },
      );
    } else {
      setShowSubmitError(true);
    }
  };

  const catCountLabel = selectedPack ? ` · ${subscriptionCategoriesCount} / ${selectedPack.maxChoice}` : '';
  const buttonDisabled = !selectedPack
    || subscriptionCategoriesCount !== selectedPack.maxChoice;

  return logged ? (
    <Container>
      <ButtonContainer>
        <Button
          onClick={handleCartButtonClick}
          leftIcon={ICON_NAME.shoppingCart}
          text={t('serieSubscriptionPackSelect_ButtonCartLabel.message', { catCountLabel })}
          disabled={buttonDisabled}
        />
        {showSubmitError && !buttonDisabled && (
          <ReStyledErrorMessage>{t('serieSubscriptionPackSelect_ButtonCartError.message')}</ReStyledErrorMessage>
        )}
      </ButtonContainer>
    </Container>
  ) : <></>;
};

export default SerieSubscriptionCartButton;

const Container = styled.div`
  display: flex;

  padding: 12px 0;

  ${mediaBreakpoint.mobile} {
    flex-direction: column;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;

  width: min-content;
  padding-left: 12px;

  ${mediaBreakpoint.mobile} {
    align-self: center;

    padding-left: 0;
  }
`;

const ReStyledErrorMessage = styled(StyledErrorMessage)`
  margin-top: 3px;

`;
